import { createContext } from 'react';
import { LiveUpcomingPageableOfferStore } from '@gp/offer';

const defaultValue: LiveUpcomingPageableOfferStore = new LiveUpcomingPageableOfferStore();
export const LiveUpcomingPageStoreContext = createContext<LiveUpcomingPageableOfferStore>(defaultValue);